<template>
  <div class="transactions">
    <v-row>
      <v-col>
        <breadcrumb :items="breadcrumbs" />
      </v-col>
    </v-row>
    <payments-table :transaction-url="transactionUrl" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BreadCrumb from '@/components/partials/BreadCrumb.vue'
import ManagedClientPaymentsTable from '@/components/tables/ManagedClientPaymentsTable.vue'

export default {
  components: {
    breadcrumb: BreadCrumb,
    'payments-table': ManagedClientPaymentsTable,
  },
  data() {
    return {
      isTransactionsLoading: false,
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          to: { name: 'dashboard' },
        },
        {
          text: 'Managed Clients',
          disabled: false,
          to: { name: 'managed-clients' },
        },
        {
          text: 'Payments',
          disabled: true,
          to: { name: 'payments' },
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['selectedStation']),
    transactionUrl() {
      return 'managed-client-payments?'
    },
  },
}
</script>
